import api from '../client';

export const ActivityService = {
  getDaily: () => api.get('/activity/daily'),
  createDaily: (data) => api.post('/activity/daily', data),
  getFeed: () => api.get('/activity/feed'),
};
